<template>
  <div class="bodyColor Page">
    <!--Banner-->
    <section class="">
        <div class="banner">
            <h1 class="PageTitle" style="">Pièces</h1>
        </div>
    </section>
    <!--after Sale Info
    <section>
      <v-row class="afterSaleBg">
        <v-row class="container" no-gutters>
          <v-col class="d-flex justify-center align-center">
            <v-row class="containerInfo d-flex  align-center" >
                <v-row class="justify-center" style="height: 100%;">
                  <row><v-col cols="12"><h2 class="infoTitle">{{ counterPro }}</h2></v-col></row>
                  <v-row><v-col cols="12"><h3 class="infoSubtitle">PROFESSIONNELS</h3></v-col></v-row>
                  <v-row><v-col cols="12"><p class="infoText">certifiés qui possèdent le savoir-faire pour que vos camions continuent de fonctionner à des performances optimales</p></v-col></v-row>
                </v-row>
            </v-row>
          </v-col>
          <v-col class="d-flex justify-center align-center">
            <v-row class="containerInfo d-flex  align-center" >
                <v-row class="justify-center" style="height: 100%;">
                  <row><v-col cols="12"><h2 class="infoTitle">{{ counterProOne }}</h2></v-col></row>
                  <v-row><v-col cols="12"><h3 class="infoSubtitle">PROFESSIONNELS</h3></v-col></v-row>
                  <v-row><v-col cols="12"><p class="infoText">certifiés qui possèdent le savoir-faire pour que vos camions continuent de fonctionner à des performances optimales</p></v-col></v-row>
                </v-row>
            </v-row>
          </v-col>
          <v-col class="d-flex justify-center align-center">
            <v-row class="containerInfo d-flex  align-center" >
                <v-row class="justify-center" style="height: 100%;">
                  <row><v-col cols="12"><h2 class="infoTitle">{{ counterProTwo }}</h2></v-col></row>
                  <v-row><v-col cols="12"><h3 class="infoSubtitle">PROFESSIONNELS</h3></v-col></v-row>
                  <v-row><v-col cols="12"><p class="infoText">certifiés qui possèdent le savoir-faire pour que vos camions continuent de fonctionner à des performances optimales</p></v-col></v-row>
                </v-row>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </section>-->

    <!--NextPart-->
    <section id="nextPart">
      <v-row class="nextBg">
        <v-col class="conainterNextPartInfo">
          <v-row style="">
            <v-col cols="12"><p>La plateforme Nexpart est désormais disponible pour que vous puissiez prendre des décisions d’achat plus rapides en&nbsp;un&nbsp;seul&nbsp;clic.</p></v-col>
            <v-col cols="12"><p>Cette plateforme en ligne vous offre un catalogue centralisé contenant une large gamme de pièces provenant de plusieurs vendeurs. Ces fonctionnalités avancées vous permettent de trouver rapidement ce dont vous avez de besoin et facilite vos achats à&nbsp;un&nbsp;seul&nbsp;endroit.</p></v-col>
          </v-row>
          <v-row>
            <v-col><a href="https://www.nexpart.com/login.php" target="_Blank"><button class="priBtn mt-5 flt-r" >CONNECTEZ-VOUS</button></a></v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>
    <!--Departement piece-->
    <section id="dptParts">
      <v-row class="dptPartsBg">
        <v-col class="conainterdptPartsInfo">
          <v-row style="">
            <v-col cols="12"> <h2>notre département des pièces</h2></v-col>
            <v-col cols="12"> <h3>VOUS AIDERA À TROUVEZ CE DONT VOUS AVEZ DE BESOIN</h3></v-col>
            <v-col cols="12"><p>Que ce soit pour l’entretien, la réparation, les pièces de carrosserie ou les accessoires, nos experts ont l’expérience et les connaissances pour répondre à tous vos besoins, quelle que soit la marque ou le modèle de votre camion.</p></v-col>
            <v-col cols="12"><p class="bold"> Appelez dès maintenant pour parler à un expert et obtenir vos pièces rapidement !</p></v-col>
          </v-row>
          <v-row>
            <v-col><router-link to="/nous-joindre"><button class="priBtn mt-5" >CONTACTEZ-NOUS</button></router-link></v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>
    <!--fleetrite-->
    <section id="fleetrite">
      <v-row class="fleetriteBg">
        <v-col class="conainterfleetriteInfo">
          <v-row style="">
            <v-col cols="12"><p><span class="bold">Conçu pour votre entreprise — en ligne et sur la route</span></p></v-col>
            <v-col cols="12"><p>Fleetrite révolutionne la façon dont les flottes et les concessionnaires trouvent, achètent et gèrent les pièces détachées. Pour certains, Fleetrite est une marque de confiance depuis des années, reconnue pour la qualité de ses pièces.</p></v-col>
            <v-col cols="12"><p>Pour d’autres, Fleetrite est une découverte moderne : une façon plus simple et plus intelligente d’acheter des pièces en ligne. Aujourd’hui, Fleetrite réunit ces deux univers au sein d’une plateforme performante conçue pour simplifier l’achat de pièces de A à Z.</p></v-col>
          </v-row>
          <v-row>
            <v-col><a href="https://www.fleetrite.com/product" target="_Blank"><button class="priBtn mt-5 flt-r" >ACHETEZ MAINTENANT</button></a></v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>
    <!--newsletters-->
    <section>
      <v-row>
        <v-col class="bgBlack">
            <h2 class="sectionTitle">PROMOTIONS&nbsp;!</h2>
            <p class="sectionSubtitle spaceNewsletter"><span class="bold">Profitez des meilleurs tarifs sur vos pièces mécaniques en ligne !</span> Nos promotions en cours sont limitées dans le temps — <span class="bold">faites vite et économisez dès aujourd’hui!</span></p>
           <router-link to="/promotion"><button style="" class="priBtn spaceNewsletter">PROFITEZ DE L’OFFRE</button></router-link>
        </v-col>
        <v-col cols="6" class="bgNewsletter">
        </v-col>
      </v-row>
    </section>
    <!--all services-->
    <section id="allServices">
      <v-row class="allServicesBG">
        <v-col><h2>DÉCOUVREZ L’ENSEMBLE DE NOS SERVICES</h2></v-col>
      </v-row>
      <v-row>
          <v-col class="serviceSection bgservice">
            <router-link to="/services"><h2 class="sectionTitle serviceSubtitle">Service</h2></router-link>
          </v-col>
          <v-col class="serviceSection bgSales" style="">
            <router-link to="/ventes"><h2 class="sectionTitle serviceSubtitle">Ventes</h2></router-link>
          </v-col>
          <v-col class="serviceSection bglocation" >
            <router-link to="/location"><h2 class="sectionTitle serviceSubtitle">LOCATION</h2></router-link>
          </v-col>
        </v-row>
    </section>
  </div>
</template>
<style scoped>
    .bodyColor { background-color: rgb(var(--ligthGray)); }
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; }
    .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/services/headerService.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    /*#region info Sale*/
      .afterSaleBg { min-height: 400px;  padding: 10px 0px; }
      .container { padding: 0px 5%; max-height: 450px; }
      .containerInfo { position: relative; padding: 50px; height: fit-content; max-width: 450px; margin: -20% 0px 0px 0px !important; background-color: rgb(var(--gray)); }
      .infoTitle { font-family: TxtOffBDI; color: rgb(var(--primary)); font-size: 78px; }
      .infoSubtitle { font-family: TxtOffBDI; text-transform: uppercase; color: white; font-size: 24px; min-width: 300px; text-align: center; padding: 20px 0px; }
      .infoText { font-family: TxtOffRe;  color: white; font-size: 24px; text-align: center;}
      .titleAfterSale { font-family: TxtOffBDI; text-transform: uppercase; text-align: center; font-size: 38px; min-width: 100%; margin: 100px 0px;  }
      .textAfterSale p { font-family: TxtOffRe; padding: 20px 0px; color: white; }
      .bgTextAfterSale { background-color: black; padding: 5% 10% !important; }
      .containerInfoAfterSale { margin: 100px 0px 50px 0px !important; padding: 0px 15%; }
      .containerImg { max-width: 350px; position: relative; }
      .frameImg { position: absolute; height: 350px; min-width: 500px; top:-50px; left: -50px; overflow: hidden; }
      .frameImg img { height: 100%; width: 100%; object-fit: cover; object-position: center center; }
      .contactBtn { padding: 0px 20%; }
    /*#endregion*/
    /*#region NextPart*/
      .nextBg { position: relative; height: 800px; width: 100%; margin-top: 40px !important; background-image: url('../../public/ressources/images/parts/NEXPART.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .conainterNextPartInfo { position: absolute; right: 10%; top:50%; transform: translate(0%,-50%); background-color: black; padding: 25px !important; max-width: 33%; }
      #nextPart p { color: white;  padding: 15px 0px; font-family: TxtOffRe; text-align: right; }
    /*#endregion*/
    /*#region Departement piece*/
      .dptPartsBg { position: relative; height: 800px; width: 100%; margin-top: 40px !important; background-image: url('../../public/ressources/images/parts/DptPieces.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; }
      .conainterdptPartsInfo { position: absolute; left: 5%; top:40%; transform: translate(0%,-50%); background-color: black; padding: 25px !important; max-width: 33%; }
      #dptParts H2 {color: white; font-family: TxtOffBDI; text-transform: uppercase; text-align: justify; font-size: 1.75em; }
      #dptParts H3 {color: rgb(var(--primary)); font-family: TxtOffBDI; text-transform: uppercase; text-align: justify; font-size: 1em; }
      #dptParts p { color: white;  padding: 15px 0px; font-family: TxtOffRe;}
    /*#endregion*/
    /*#region fleetrite*/
      .fleetriteBg { position: relative; display: flex; align-items: center; min-height: 500px; width: 100%; padding: 50px 0; margin-top: 40px !important; background-image: url('../../public/ressources/images/parts/banniereFleetrite.jpg'); background-size: cover; background-position: left center; background-repeat: no-repeat; }
      .conainterfleetriteInfo { flex: 0 0 auto; max-width: 38%; margin-left: auto; margin-right: 8%; background-color: rgba(0,0,0,0.85); padding: 30px !important; }
      #fleetrite H2 {color: white; font-family: TxtOffBDI; text-transform: uppercase; text-align: right; font-size: 1.75em; }
      #fleetrite H3 {color: rgb(41,126,135); font-family: TxtOffBDI; text-transform: uppercase; text-align: right; font-size: 1em; }
      #fleetrite p { color: white;  padding: 15px 0px; font-family: TxtOffRe; text-align: right; }
      #fleetrite button { background-color: rgb(41,126,135); }
    /*#endregion*/
    /*#region promo*/
      .promoBG { margin-top: 40px !important; position: relative; height: 900px; width: 100%; background-image: url('../../public/ressources/images/services/promoBG.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat;  }
      .conainterpromoInfo { position: absolute; left: 50%; top:55%; transform: translate(-50%,-50%); padding: 25px !important; max-width: 33%; }
      .conainterpromoInfo h2 { text-align: center; color: white;  text-transform: uppercase; font-size: 36px; }
      .conainterpromoInfo p { text-align: center; color: white; padding: 30px 0px; font-size: 24px; font-family: TxtOffRe; }
    /*#endregion*/
    /*#region newsletter*/
      .bgNewsletter { display: block; background-image: url('../../public/ressources/images/home/infolettre.jpg'); background-position: center center; background-size: cover; background-repeat: no-repeat; }
      .bgBlack { background-color: black; padding: 9% 5% !important; }
      .spaceNewsletter { margin: 20px 0px; }
    /*#endregion*/
    /*#region allServices*/
      .allServicesBG { background-color: rgb(var(--gray)); }
      .allServicesBG h2 { text-align: center; color: white; padding: 100px 0px; font-size: 36px; font-family: TxtOffBDI; }
      .bgSales { background-image: url('../../public/ressources/images/home/serviceSales.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bgparts { background-image: url('../../public/ressources/images/home/PIECES.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bgservice { background-image: url('../../public/ressources/images/home/SERVICE.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bglocation { background-image: url('../../public/ressources/images/home/LOCATION.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .serviceTitle { font-family: TxtOffBDI; padding: 10% 0px; text-align: center; margin: 10px 0px !important; text-transform: uppercase; color: white; }
      .serviceSubtitle { font-family: TxtOffBDI; padding: 30% 0px; text-align: center; margin: 10px 0px; text-transform: uppercase; color: white; }
      .serviceSection:hover  .serviceTitle {color: rgb(var(--primary)); cursor: pointer; }
      .serviceSection:hover  .serviceSubtitle {color: rgb(var(--primary)); cursor: pointer;}

    /*#endregion*/
    @media handheld, only screen and (max-width: 600px) {
      .afterSaleBg { padding: 0px; }
      .containerInfo { min-width: 100% !important; padding: 20px 0px; }
      .containerImg { max-width: 100% !important; min-width: 100%; }
      .frameImg { min-width: auto; height: auto; }
      .textAfterSale p { font-size: 12px; }
      .titleAfterSale { margin: 0px 0px !important;  }
      .contactBtn { padding: 0px 5%; }
      .conainterNextPartInfo  { max-width: 80% !important; }
      #nextPart p { font-size: 12px !important; }
      .conainterpromoInfo p { padding: 20px 0px; font-size: 12px !important; }
      .priBtn { font-size: 18px; }
      .conainterpromoInfo { position: absolute; left: 50%; top:40%; transform: translate(-50%,-50%); padding: 25px !important; max-width: 100%; }
      .promoBG { height: 400px;  }
      .bgparts { min-width: 100%; }
      .bgservice { min-width: 100%; }
      .bglocation { min-width: 100%; }
      .logoOnCommand {  float: right; max-width: 100%; }
    }
    @media handheld, only screen and (max-width: 960px) {
      .conainterNextPartInfo  { max-width: 50%; }
      #nextPart p { font-size: 16px; }
      .conainterpromoInfo p { padding: 20px 0px; font-size: 16px ; }

      .container { padding: 0px 25px; max-height: unset; }
      .containerInfo { width: 100%; min-width: 500px; max-width: 100%; margin: 20px 0px !important; }

      .titleAfterSale { font-size: 24px; margin: 40px 0px;  }
      .containerImg { max-width: unset; min-width: 100%; margin: auto; }
      .frameImg { position: relative; margin: 40px auto; top: 0px; left: 0px; }
      .containerInfoAfterSale { margin: 40px 0px !important; padding: 0px 25px; }

      .conainterdptPartsInfo { max-width: 90%;}
      .conainterfleetriteInfo { max-width: 90%; margin-right: 5%; margin-left: 5%; }
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
  name: 'Parts',
  data:()=>({
    counterPro: 0,
    counterProOne: 0,
    counterProTwo: 0,
    animationDurationCount: 1000,
  }),
  mounted() {
    this.animateProCounter();
    this.animateProOneCounter();
    this.animateProTwoCounter();

  },
  methods:{
    animateProCounter() {
      const maxCount = 600;
      const duration = this.animationDurationCount; // Durée totale de l'animation en millisecondes
      const stepTime = Math.abs(Math.floor(duration / maxCount));

      let currentCount = 0;
      const timer = setInterval(() => {
        currentCount++;
        this.counterPro = currentCount;
        if(currentCount === maxCount) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    animateProOneCounter() {
      const maxCount = 600;
      const duration = this.animationDurationCount; // Durée totale de l'animation en millisecondes
      const stepTime = Math.abs(Math.floor(duration / maxCount));

      let currentCount = 0;
      const timer = setInterval(() => {
        currentCount++;
        this.counterProOne = currentCount;
        if(currentCount === maxCount) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    animateProTwoCounter() {
      const maxCount = 600;
      const duration = this.animationDurationCount; // Durée totale de l'animation en millisecondes
      const stepTime = Math.abs(Math.floor(duration / maxCount));

      let currentCount = 0;
      const timer = setInterval(() => {
        currentCount++;
        this.counterProTwo = currentCount;
        if(currentCount === maxCount) {
          clearInterval(timer);
        }
      }, stepTime);
    },
  },
  components: { }
}
</script>
